module.exports = __webpack_public_path__ + "img/coins.7b36735.svg";